import { BoundStandardSwitch } from "lib/@components/binding/bound-components"
import { Alert } from "@mui/material"
import { FEATURE_FLAG_API_EXPOSE_ZEROU } from "routes/sharing/api-feature-flags"
import { Feature } from "lib/@components/feature"

export function ExposeZeroUShareLinkSetting() {
    return (
        <Feature feature={FEATURE_FLAG_API_EXPOSE_ZEROU}>
            <BoundStandardSwitch sideEffects field="exposeZeroUs" label="Can retrieve ZeroU tasks via the API" />
            <Alert severity="warning">
                This will expose 0U tasks to the API. Allowing 3rd party software to retrieve them. To expose these
                tasks without using this setting, please update the tasks in the regime.
            </Alert>
        </Feature>
    )
}
